import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Image } from "react-image-and-background-image-fade"
import v2_food_logo from "../../images/v2-food-logo.png"
import zero_hunger from "../../images/zero-hunger.png"
import responsible_consumption from "../../images/responsible-consumption.png"
import climate_action from "../../images/climate-action.png"
import life_on_land from "../../images/life-on-land.png"

const V2FoodMapDetail = () => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid item lg={3} xl={2}>
          <Image
            src={v2_food_logo}
            width="692px"
            height="304px"
            isResponsive
            disableLoader
            alt="V2 Food"
            style={{ backgroundSize: "cover", backgroundPosition: "center" }}
          />
          {/* <StaticImage
            src="../../images/v2-food-logo.png"
            alt="V2 Food"
            layout="fullWidth"
          /> */}
        </Grid>
      </Grid>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid item lg={3} xl={2} container spacing={2}>
          <Grid item xs={6}>
            <Image
              src={zero_hunger}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="zero hunger"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/zero-hunger.png"
              alt="zero hunger"
              layout="fullWidth"
            /> */}
          </Grid>
          <Grid item xs={6}>
            <Image
              src={responsible_consumption}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="responsible consumption and production"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/responsible-consumption.png"
              alt="responsible consumption and production"
              layout="fullWidth"
            /> */}
          </Grid>
          <Grid item xs={6}>
            <Image
              src={climate_action}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="climate action"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/climate-action.png"
              alt="climate action"
              layout="fullWidth"
            /> */}
          </Grid>
          <Grid item xs={6}>
            <Image
              src={life_on_land}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="life on land"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
            {/* <StaticImage
              src="../../images/life-on-land.png"
              alt="life on land"
              layout="fullWidth"
            /> */}
          </Grid>
        </Grid>
        <Grid item lg={9} xl={10} container>
          <Grid item xs={12}>
            <StyledDetailHeader>Plant-Based Meat</StyledDetailHeader>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailLocation>Based in Australia</StyledDetailLocation>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              borderBottom: "3px solid #0F6494",
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            container
          >
            <Grid item xs={6}>
              <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
            </Grid>
            <Grid item xs={6}>
              <StyledDetailSubheaderContent>
                Sustainable Food & Agriculture
                <br />
                Climate & Water Solutions
              </StyledDetailSubheaderContent>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              About the Company
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Producer of plant-based meat using protein extracted from legumes.
            </StyledDetailSubheaderContent>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              Impact Thesis
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Accelerating consumers’ transition to a more plant-rich diet and
              reducing GHG emissions, water use and land use.
            </StyledDetailSubheaderContent>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default V2FoodMapDetail
